/* Halftime — détourage automatique des photos produit (fond blanc → transparent).
   Les photos du site font 1920 × 2500 avec une fine bande noire à gauche et à droite :
   · on retire ces bandes (zone utile ≈ 1868 × 2500) ;
   · on rend transparent le blanc relié aux bords de la photo (le blanc à l'intérieur du maillot reste).
   Photos transparentes fournies (PNG du même nom que la photo produit, dans Shopify Fichiers) :
   utilisées en priorité ; à défaut, détourage automatique du fond blanc.
   Site classique : photos blanches uniquement dans le détail de l'annonce (galeries de la fiche produit).
   Mode rétro : photos transparentes partout. Ailleurs (cartes, menus, fiche, rail 3D) : transparent.
   Résultat gardé en mémoire dans le navigateur (IndexedDB « ht-detour1 »). */
(function () {
  'use strict';
  if (window.HTDetour) return;
  var H = document.documentElement;
  H.classList.add('htd-on');
  var WHITE = 232;
  function retro() { return H.classList.contains('vj-retro'); }
  var DETAIL = '.product__media-list, .product-media-modal, .thumbnail-list, .k32-gal, .htp-gal, .vlx-gal, [data-htd-skip]';

  /* ---------- découpe ---------- */
  function cutCanvas(img, opt) {
    opt = opt || {};
    var NW = img.naturalWidth || img.width, NH = img.naturalHeight || img.height;
    if (!NW || !NH) return null;
    var max = opt.max || 1000, s = Math.min(1, max / Math.max(NW, NH));
    var w = Math.round(NW * s), h = Math.round(NH * s);
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    var d;
    try { d = x.getImageData(0, 0, w, h).data; } catch (e) { return null; }
    function lum(p) { var o = 4 * p; return d[o] + d[o + 1] + d[o + 2]; }
    /* bandes sombres sur les bords */
    function colDark(a) { var n = 0, k = 0; for (var b = 0; b < h; b += 7) { k++; if (lum(b * w + a) < 240) n++; } return n / k > 0.85; }
    function rowDark(b) { var n = 0, k = 0; for (var a = 0; a < w; a += 7) { k++; if (lum(b * w + a) < 240) n++; } return n / k > 0.85; }
    var lim = Math.round(w * 0.06), L = 0, R = 0, T = 0, B = 0;
    while (L < lim && colDark(L)) L++;
    while (R < lim && colDark(w - 1 - R)) R++;
    while (T < lim && rowDark(T)) T++;
    while (B < lim && rowDark(h - 1 - B)) B++;
    /* marge pour le dégradé gris entre la bande et le blanc */
    var pad = Math.max(2, Math.round(w * 0.004));
    if (L) L += pad; if (R) R += pad; if (T) T += pad; if (B) B += pad;
    var x0 = L, y0 = T, x1 = w - R, y1 = h - B, cw = x1 - x0, ch = y1 - y0;
    if (cw < 20 || ch < 20) return null;
    var n = cw * ch, bg = new Uint8Array(n), st = new Int32Array(n), sp = 0, i, p;
    function white(q) { var o = 4 * ((y0 + (q / cw | 0)) * w + x0 + q % cw); return d[o] > WHITE && d[o + 1] > WHITE && d[o + 2] > WHITE; }
    function push(q) { if (!bg[q] && white(q)) { bg[q] = 1; st[sp++] = q; } }
    for (i = 0; i < cw; i++) { push(i); push((ch - 1) * cw + i); }
    for (i = 0; i < ch; i++) { push(i * cw); push(i * cw + cw - 1); }
    while (sp) {
      p = st[--sp]; var X = p % cw;
      if (X > 0) push(p - 1);
      if (X < cw - 1) push(p + 1);
      if (p >= cw) push(p - cw);
      if (p < n - cw) push(p + cw);
    }
    var nb = 0; for (i = 0; i < n; i++) nb += bg[i];
    /* pas un fond blanc (ou presque rien à garder) : on ne touche pas */
    if (nb < n * 0.08 || n - nb < n * 0.03) return null;
    var out = x.createImageData(cw, ch), od = out.data, bx0 = cw, by0 = ch, bx1 = -1, by1 = -1;
    for (p = 0; p < n; p++) {
      var X2 = p % cw, Y2 = p / cw | 0, o = 4 * ((y0 + Y2) * w + x0 + X2), q = 4 * p;
      od[q] = d[o]; od[q + 1] = d[o + 1]; od[q + 2] = d[o + 2];
      if (bg[p]) { od[q + 3] = 0; continue; }
      var edge = (X2 > 0 && bg[p - 1]) || (X2 < cw - 1 && bg[p + 1]) || (Y2 > 0 && bg[p - cw]) || (Y2 < ch - 1 && bg[p + cw]);
      var a = 255;
      if (edge) { var m = Math.min(d[o], d[o + 1], d[o + 2]); a = Math.max(90, Math.min(255, Math.round((255 - m) * 255 / (255 - WHITE + 20)))); }
      od[q + 3] = a;
      if (X2 < bx0) bx0 = X2; if (X2 > bx1) bx1 = X2; if (Y2 < by0) by0 = Y2; if (Y2 > by1) by1 = Y2;
    }
    var r = document.createElement('canvas'), rx;
    if (opt.trim) {
      var m2 = 2; bx0 = Math.max(0, bx0 - m2); by0 = Math.max(0, by0 - m2); bx1 = Math.min(cw - 1, bx1 + m2); by1 = Math.min(ch - 1, by1 + m2);
      r.width = bx1 - bx0 + 1; r.height = by1 - by0 + 1; rx = r.getContext('2d');
      rx.putImageData(out, -bx0, -by0);
    } else {
      r.width = cw; r.height = ch; rx = r.getContext('2d'); rx.putImageData(out, 0, 0);
    }
    return r;
  }


  /* ---------- photo transparente fournie (PNG) ---------- */
  var UUID = /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  function pngOf(src, w) {
    if (!src) return null;
    var u = String(src).split('?')[0], i = u.lastIndexOf('/');
    if (i < 0 || !/\/files\/[^\/]+\.(jpe?g|webp)$/i.test(u)) return null;
    var base = u.slice(i + 1).replace(/\.(jpe?g|webp)$/i, '').replace(UUID, '');
    if (/^\/\//.test(u)) u = 'https:' + u;
    return u.slice(0, u.lastIndexOf('/') + 1) + base + '.png' + (w ? '?width=' + w : '');
  }
  function trimAlpha(img, max) {
    var NW = img.naturalWidth || img.width, NH = img.naturalHeight || img.height;
    if (!NW || !NH) return null;
    var s = Math.min(1, (max || 1000) / Math.max(NW, NH)), w = Math.round(NW * s), h = Math.round(NH * s);
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, w, h);
    var d; try { d = x.getImageData(0, 0, w, h).data; } catch (e) { return null; }
    var x0 = w, y0 = h, x1 = -1, y1 = -1, X, Y;
    for (Y = 0; Y < h; Y++) for (X = 0; X < w; X++) if (d[4 * (Y * w + X) + 3] > 8) { if (X < x0) x0 = X; if (X > x1) x1 = X; if (Y < y0) y0 = Y; if (Y > y1) y1 = Y; }
    if (x1 < 0) return null;
    x0 = Math.max(0, x0 - 2); y0 = Math.max(0, y0 - 2); x1 = Math.min(w - 1, x1 + 2); y1 = Math.min(h - 1, y1 + 2);
    var r = document.createElement('canvas'); r.width = x1 - x0 + 1; r.height = y1 - y0 + 1;
    r.getContext('2d').drawImage(c, -x0, -y0);
    return r;
  }
  /* rail 3D : photo transparente fournie (recadrée), sinon détourage automatique de la photo chargée */
  function cut3d(img, cb) {
    var p = pngOf(img.currentSrc || img.src, 800);
    function auto() { var c = null; try { c = cutCanvas(img, { trim: 1, max: 800 }); } catch (e) {} cb(c); }
    if (!p) return auto();
    load(p).then(function (i) { var c = trimAlpha(i, 800); c ? cb(c) : auto(); }, auto);
  }

  /* ---------- cache ---------- */
  var db = null, dbReady = new Promise(function (res) {
    try {
      var q = indexedDB.open('ht-detour1', 1);
      q.onupgradeneeded = function () { q.result.createObjectStore('c'); };
      q.onsuccess = function () { db = q.result; res(); };
      q.onerror = function () { res(); };
      setTimeout(res, 800);
    } catch (e) { res(); }
  });
  function dbGet(k) { return dbReady.then(function () { return new Promise(function (res) { if (!db) return res(null); try { var g = db.transaction('c').objectStore('c').get(k); g.onsuccess = function () { res(g.result || null); }; g.onerror = function () { res(null); }; } catch (e) { res(null); } }); }); }
  function dbPut(k, v) { try { db && db.transaction('c', 'readwrite').objectStore('c').put(v, k); } catch (e) {} }
  var mem = {};
  function keyOf(src, opt) { return src.replace(/^https?:/, '').replace(/[?&]v=\d+/, '') + (opt && opt.trim ? '#t' : ''); }
  function load(src) { return new Promise(function (res, rej) { var i = new Image(); i.crossOrigin = 'anonymous'; i.decoding = 'async'; i.onload = function () { res(i); }; i.onerror = rej; i.src = src; }); }
  /* url(src) → Promise<url blob détourée | null> */
  function url(src, opt) {
    var k = keyOf(src, opt) + '|2';
    if (mem[k]) return mem[k];
    return (mem[k] = dbGet(k).then(function (b) {
      if (b) return b === 'none' ? null : URL.createObjectURL(b);
      var p = pngOf(src, (/[?&]width=(\d+)/.exec(src) || [])[1]);
      var viaPng = p ? load(p).then(function (img) {
        if (!(opt && opt.trim)) return p;
        var c = trimAlpha(img, 1000); if (!c) return p;
        return new Promise(function (res) { c.toBlob(function (blob) { res(blob ? URL.createObjectURL(blob) : p); }, 'image/webp', 0.9); });
      }) : Promise.reject();
      return viaPng.catch(function () { return load(src).then(function (img) {
        var c = cutCanvas(img, opt);
        if (!c) { dbPut(k, 'none'); return null; }
        return new Promise(function (res) {
          c.toBlob(function (blob) { if (!blob) return res(null); dbPut(k, blob); res(URL.createObjectURL(blob)); }, 'image/webp', 0.9);
        });
      }); });
    }).catch(function () { return null; }));
  }

  /* ---------- images de la page ---------- */
  var queue = [], busy = 0;
  function isPhoto(img) {
    var s = img.currentSrc || img.src || '';
    if (!/\/files\//.test(s) || /^blob:|^data:/.test(s)) return false;
    var r = img.naturalWidth / img.naturalHeight;
    return r > 0.752 && r < 0.775;
  }
  function done(img, v) { img.setAttribute('data-htd', v); }
  var OLD = /\/files\/v[jl]-[^\/?]*\.webp/;
  function handle(img) {
    /* anciens détourages (vj-… / vl-…) faits sur les anciennes photos : on les écarte,
       le script passe alors à la photo actuelle du produit, détourée ici */
    if (OLD.test(img.getAttribute('src') || '')) { img.removeAttribute('srcset'); img.src = 'data:image/gif;base64,x'; return; }
    if (img.hasAttribute('data-htd') || img.hasAttribute('data-ht-orig')) return;
    if (!retro() && img.closest(DETAIL)) { done(img, 'detail'); return; }
    if (!img.complete || !img.naturalWidth) return; /* on attend le load */
    if (!isPhoto(img)) { done(img, 'skip'); return; }
    done(img, 'wait');
    queue.push(img); pump();
  }
  function pump() {
    while (busy < 2 && queue.length) {
      (function (img) {
        busy++;
        var src = img.currentSrc || img.src, w = Math.min(1000, Math.max(300, Math.round((img.clientWidth || 400) * (window.devicePixelRatio || 1) * 1.1)));
        src = src.replace(/([?&])width=\d+/, '$1width=' + w);
        if (!/[?&]width=/.test(src)) src += (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
        var trim = !!img.closest('.k32-card');
        url(src, { trim: trim }).then(function (u) {
          busy--;
          if (u) {
            img.setAttribute('data-htd-orig', img.getAttribute('src') || ''); if (img.srcset) { img.setAttribute('data-htd-srcset', img.srcset); img.removeAttribute('srcset'); }
            img.removeAttribute('sizes');
            img.setAttribute('data-htd-swap', ''); img.src = u; done(img, 'ok'); setTimeout(function () { img.removeAttribute('data-htd-swap'); }, 0);
          } else done(img, 'none');
          pump();
        });
      })(queue.shift());
    }
  }
  function scan(root) {
    var list = (root || document).querySelectorAll ? (root || document).querySelectorAll('img') : [];
    for (var i = 0; i < list.length; i++) handle(list[i]);
    if (root && root.tagName === 'IMG') handle(root);
  }
  document.addEventListener('load', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && !/^blob:/.test(t.src)) handle(t); }, true);
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      if (m.type === 'attributes') {
        var t = m.target;
        if (t.tagName === 'IMG' && !/^blob:/.test(t.src) && t.getAttribute('data-htd') !== 'wait' && !t.hasAttribute('data-htd-swap')) { t.removeAttribute('data-htd'); handle(t); }
      } else for (var i = 0; i < m.addedNodes.length; i++) { var a = m.addedNodes[i]; if (a.nodeType === 1) scan(a); }
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);


  /* passage site classique ↔ rétro sans recharger : galeries de l'annonce blanches / transparentes */
  var wasRetro = retro();
  new MutationObserver(function () {
    var now = retro(); if (now === wasRetro) return; wasRetro = now;
    var list = document.querySelectorAll(DETAIL.split(',').map(function (q) { return q.trim() + ' img'; }).join(','));
    for (var i = 0; i < list.length; i++) {
      var im = list[i];
      if (now && im.getAttribute('data-htd') === 'detail') { im.removeAttribute('data-htd'); handle(im); }
      else if (!now && im.hasAttribute('data-htd-orig')) {
        im.setAttribute('data-htd-swap', ''); im.src = im.getAttribute('data-htd-orig');
        var ss = im.getAttribute('data-htd-srcset'); if (ss) im.srcset = ss;
        im.removeAttribute('data-htd-orig'); im.removeAttribute('data-htd-srcset'); done(im, 'detail');
        (function (m) { setTimeout(function () { m.removeAttribute('data-htd-swap'); }, 0); })(im);
      }
    }
  }).observe(H, { attributes: true, attributeFilter: ['class'] });

  window.HTDetour = { cutCanvas: cutCanvas, url: url, png: pngOf, trimAlpha: trimAlpha, cut3d: cut3d };
})();
